/**
 * @element Spinner
 * @description Standardized circular loader.
 */
export const Spinner = ({ size = "w-8 h-8", color = "border-primary" }) => (
  <div className={`${size} border-4 border-gray-100 border-t-current ${color} rounded-full animate-spin`} />
);